import React, { Component } from 'react'
import Navigation from './Components/Navigation';
import {BrowserRouter ,Route} from 'react-router-dom';
import LandingPage from './Components/LandingPage/LandingPage';
import Footer from './Components/LandingPage/Footer';
import Services from './Components/Services/Services' 
import Register from './Components/Register/Register';
import {connect} from 'react-redux';
import BackDrop from './Components/BackDrop';
import DividerForm from './Components/Register/DividerForm'
import Editvendor from './Components/Editvendor/Editvendor';
import EditForm from './Components/Editvendor/EditForm';
import Quickexplore from './Components/Quick/Quickexplore';

class App extends Component {
  
  render() {
    
    return (
      <BrowserRouter>
      <BackDrop />
      
      <Navigation/>
      <Route path="/" component={LandingPage}  exact/>
      <Route path="/services" component={Services} exact />
      <Route path="/register" component={DividerForm} exact />
      {
        this.props.state_data.isAuth ?   
        <Route path="/register/vendorform" exact component={Register} />  
        :
        ""
      }
      <Route path="/edit/vendor" component={Editvendor} exact />
      <Route path="/edit/vendor/form" component={EditForm} exact />
      <Route path="/services/:service" component={Quickexplore} exact />
      <Footer />
      </BrowserRouter>
    )
  }
}

const mapStateToProps =state=>({
  state_data : state.reducer
})

export default connect(mapStateToProps)(App)

